export const carousel = () => {
    window.addEventListener('slideChange', (event) => {
        const carouselId = event.detail;
        const carousel = document.querySelector('#' + carouselId);
        if (!carousel || !carousel.classList.contains('carousel__images'))
            return;
        const sectionId = carousel.getAttribute('data-parent-section');
        if (!sectionId)
            return;
        const section = document.querySelector('[data-section-id="' + sectionId + '"]');
        if (!section)
            return;
        const infoSlides = section.querySelectorAll('.info__slide');
        infoSlides.forEach((slide) => {
            slide.classList.remove('info__slide--show');
        });
        const currentSlideEl = section.querySelector('.slideshow__slide.is-selected');
        if (!currentSlideEl)
            return;
        const currentSlide = currentSlideEl.getAttribute('data-slide-image');
        if (!currentSlide)
            return;
        const slideInfo = section.querySelector('.info__slide[data-slide-info="' + currentSlide + '"]');
        if (!slideInfo)
            return;
        slideInfo.classList.add('info__slide--show');
    });
};
